import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import { ErrorBoundary } from '@/app/providers/error-boundary/ErrorBoundary'
import { AppRouter } from '@/app/providers/router/appRouter.tsx'
import { queryClient } from '@/shared/api/react-query'
import { theme } from '@/shared/theme'
import 'ldrs/react/DotStream.css'
import '@/shared/ui/toast/toast-styles.css'
import { useSetLocale } from '@/shared/hooks'
import { getToastIcon } from '@/shared/ui/toast'

export const App = () => {
  useSetLocale()

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <AppRouter />
          <CssBaseline />
          <ToastContainer draggable hideProgressBar icon={getToastIcon} />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
